import { wpd } from './common';
export var Level;
(function (Level) {
    Level[Level["Debug"] = 0] = "Debug";
    Level[Level["Info"] = 1] = "Info";
    Level[Level["Warn"] = 2] = "Warn";
    Level[Level["Error"] = 3] = "Error";
})(Level || (Level = {}));
const exp = {
    printToConsole: false,
    debug,
    info,
    warn,
    error,
    dump,
    history,
    watch,
    stringify,
    clear
};
/**
 * 存储历史日志
 */
let _history = [];
/**
 * 存储日志变化监听器
 */
const _watchers = new Set();
function _log(content, level) {
    const contentStr = typeof content === 'object'
        // Error 实现了toString，可以忽略该lint error(no-base-to-string)
        // eslint-disable-next-line
        ? JSON.stringify(content, (k, v) => v instanceof Error ? v.toString() : v)
        : content;
    const it = { content: contentStr, level, ts: Date.now() };
    _history.push(it);
    if (exp.printToConsole) {
        const method = Level[level].toLowerCase();
        console[method](content);
    }
    // 避免卡住主线程
    setTimeout(() => {
        _watchers.forEach(watcher => watcher(Object.assign({}, it)));
    }, 1);
}
function debug(content) {
    _log(content, Level.Debug);
}
function info(content) {
    _log(content, Level.Info);
}
function warn(content) {
    _log(content, Level.Warn);
}
function error(content) {
    if (wpd.Log2Console)
        console.error(content);
    _log(content, Level.Error);
}
/**
 * 获取所有历史日志
 */
function history() {
    return _history.slice(0);
}
/**
 * 将日志历史输出为字符串文本
 */
function dump() {
    return _history.map((log) => stringify(log)).join('\n');
}
/**
 * 清空日志历史
 */
function clear() {
    _history = [];
}
/**
 * 监听日志更新
 * @param fn
 * @return 取消监听函数
 */
function watch(fn) {
    _watchers.add(fn);
    return () => {
        _watchers.delete(fn);
    };
}
/**
 * 将日志对象转换为字符串
 * @param log LogItem
 */
function stringify(log, opts) {
    const _opts = Object.assign({ tag: true, time: true }, opts);
    const d = new Date(log.ts);
    const tagStr = `${Level[log.level]} `;
    const timeStr = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}`;
    return `${_opts.tag ? tagStr : ''}${_opts.time ? timeStr : ''}> ${log.content}`;
}
export default exp;
//# sourceMappingURL=logger.js.map